import { preparePhone } from '../phone';
import { addMinutes, getTimeForTimezone } from '../time';
export var prepareCallbackParams = function prepareCallbackParams(values, options) {
  var recommendations = options.recommendations,
    recommendationTime = options.recommendationTime,
    timezoneDiff = options.timezoneDiff;
  var callbackTime = getTimeForTimezone(values.time, timezoneDiff);
  var customerPhone = preparePhone(values.phone);
  var requestParams = {
    agentPhone: values.agentPhone,
    callRightNow: false,
    customerPhone: customerPhone,
    time: callbackTime
  };
  if (recommendations.length > 0 && values.withRecommendations) {
    requestParams.recommendations = recommendations.map(function (data, idx) {
      var agentPhone = data.agentPhone;
      var position = idx + 1;
      return {
        data: data,
        agentPhone: agentPhone,
        callRightNow: false,
        customerPhone: customerPhone,
        time: addMinutes(callbackTime, recommendationTime * position)
      };
    });
  }
  return requestParams;
};